/**
 *    Copyright 2018 the original author or authors
 *
 *    Licensed under the Apache License, Version 2.0 (the "License");
 *    you may not use this file except in compliance with the License.
 *    You may obtain a copy of the License at
 *
 *        http://www.apache.org/licenses/LICENSE-2.0
 *
 *    Unless required by applicable law or agreed to in writing, software
 *    distributed under the License is distributed on an "AS IS" BASIS,
 *    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *    See the License for the specific language governing permissions and
 *    limitations under the License.
 */
import * as tslib_1 from "tslib";
import { NgModule, InjectionToken } from '@angular/core';
import { ModelMetaService } from './modelMeta.service';
import { ExtModelMetaConfig } from './models/extModelMeta.conf';
import { EXT_REST_CONFIG } from '../rest';
export var EXT_MODEL_META_CONFIG = new InjectionToken('extModelMeta.config');
export function modelMetaFactory(restConfig, config) {
    return new ExtModelMetaConfig(config);
}
export var MODEL_META_PROVIDER = {
    provide: ExtModelMetaConfig,
    useFactory: modelMetaFactory,
    deps: [EXT_REST_CONFIG, EXT_MODEL_META_CONFIG]
};
/**
 * Base for Model meta module
 *
 * @author Randika Hapugoda
 */
var ExtendzModelMetaModule = /** @class */ (function () {
    function ExtendzModelMetaModule() {
    }
    ExtendzModelMetaModule_1 = ExtendzModelMetaModule;
    ExtendzModelMetaModule.forRoot = function (config) {
        return {
            ngModule: ExtendzModelMetaModule_1,
            providers: [
                {
                    provide: EXT_MODEL_META_CONFIG,
                    useValue: config
                },
                MODEL_META_PROVIDER
            ]
        };
    }; // forRoot()
    ExtendzModelMetaModule = ExtendzModelMetaModule_1 = tslib_1.__decorate([
        NgModule({
            providers: [ModelMetaService]
        })
    ], ExtendzModelMetaModule);
    return ExtendzModelMetaModule;
    var ExtendzModelMetaModule_1;
}()); // class
export { ExtendzModelMetaModule };
//# sourceMappingURL=modelMeta.module.js.map